<template>
  <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light shadow"
    style="background-color: #3d3e40 !important; border-right: 1px solid rgb(255 255 255 / 12%)" id="sidenav-main">
    <div class="container-fluid">

      <!--Toggler-->
      <navbar-toggle-button @click.native="showSidebar">
        <span class="navbar-toggler-icon"></span>
      </navbar-toggle-button>
      <router-link class="navbar-brand" to="/">
        <img src="/images/logo.png" style="height: 80px;" class="navbar-brand-img" alt="...">
      </router-link>

      <slot name="mobile-right">
      </slot>
      <slot></slot>
      <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">

        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img :src="logoUrl">
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links">
          </slot>
          <li class="nav-item" @click="logoutAction">
            <b-link class="nav-link">
              <i class="fas fa-sign-out-alt" style="color: #e4e5e6"></i> Çıkış Yap
            </b-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import SidebarDropdown from '../../components/SidebarDropdown'
import NavbarToggleButton from '../NavbarToggleButton'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'sidebar',
  components: {
    NavbarToggleButton,
    SidebarDropdown,
  },
  props: {
    autoClose: {
      type: Boolean,
      default: true,
      description: 'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },

  computed: {
    ...mapGetters(['user', 'roles']),
    logoUrl() {
      return this.user && this.user.company.logo_url ? this.user.company.logo_url : '/images/logo.png'
    },
  },
  methods: {
    ...mapActions(['logout']),
    closeSidebar() {
      this.$sidebar.displaySidebar(false)
    },
    logoutAction() {
      this.logout().then(() => {
        this.$router.go({ name: 'login' });
      })
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true)
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
